/** Created by azhou on 2019/3/8.*/
<template>
    <div class="blank_space">
      <el-alert :title="TitleMsg" type="success" :class="BasicInfo.edit_status==1&&'red'" :closable="false" center/>
      <el-row :gutter="20">
        <el-col :span="16">
          <p class="d-center-end mt-3">
            <span  class="ml-auto text-link" v-if="BasicInfo.edit_status==1"  @click="editinformation">查看提交</span>
            <span class="ml-auto text-link" @click="confirmSubmit" v-else>{{showEditModel ? '取消编辑':'编辑'}}</span>
          </p>
          <div class="mt-4 mb-3">
            <left-text-border class="w-75 mb-3"
                              leftText="酒店名称"
                              :placeholder="BasicInfo.title"
                              required
                              v-if="showEditModel"
                              inputId="inputTitle"
                              v-model="title"/>
            <div class="d-flex mb-3" v-else><left-text leftText="酒店名称"/>{{BasicInfo.title}}</div>
            <div class="d-start-start mb-3 mt-4">
              <left-text leftText="营业执照"/>
              <span class="list-text" v-if="!StoreBasicInfo.certpic&&!showEditModel">未上传</span>
              <upload-image @fileChange="(imgs)=>{verifyImg = imgs[0];}"
                            :existImgs="StoreBasicInfo.certpic" :maxLength="1" :editMode="showEditModel"/>
            </div>
            <div class="d-flex mb-3 mt-4">
              <div class="d-start-start">
                <left-text leftText="消防验收合格证"/>
                <span class="list-text" v-if="!certfire&&!showEditModel">未上传</span>
                <upload-image @fileChange="(imgs)=>{certfire = imgs[0];}"
                              :existImgs="certfire" :maxLength="1" :editMode="showEditModel"/>
              </div>
              <div class="d-start-start">
                <left-text leftText="卫生许可证" class="ml-4"/>
                <span class="list-text" v-if="!certheal&&!showEditModel">未上传</span>
                <upload-image @fileChange="(imgs)=>{certheal = imgs[0];}"
                              :existImgs="certheal" :maxLength="1" :editMode="showEditModel"/>
              </div>
              <div class="d-start-start">
                <left-text leftText="特种行业许可证 " class="ml-4"/>
                <span class="list-text" v-if="!certspec&&!showEditModel">未上传</span>
                <upload-image @fileChange="(imgs)=>{certspec = imgs[0];}"
                              :existImgs="certspec" :maxLength="1" :editMode="showEditModel"/>
              </div>
            </div>
            <left-text-border class="mb-3"
              leftText="省市区"
              disabled
              v-show="!showEditModel"
              v-model="pcd"
              required  
            />
            <select-city class="mb-3"
              leftText="省市区"
              required
              v-show="showEditModel"
              @getCityInfo="getCityInfo"
              :provinceId="BasicInfo.province*1"
              :cityId="BasicInfo.city*1"
              :districtId="BasicInfo.district*1"
            />
            <left-text-border class="mb-3"
              leftText="详细地址"
              :disabled="!showEditModel"
              placeholder="请输入详细地址"
              v-model="BasicInfo.address"
              @blur="(content) => {this.addressDetail = content}"
            />
          </div>
          <div class="d-center-start" v-show="showEditModel">
            <left-text leftText="修改原因"/>
            <el-radio-group v-model="reason">
              <el-radio :label="item" v-for="item in reasonsArr" :key="item">{{item}}</el-radio>
            </el-radio-group>
          </div>
          <div class="d-center-start" v-show="reason === '手动填写其他原因'">
            <left-text/>
            <el-input class="mt-3" v-model="otherReason"/>
          </div>
          <el-button @click="reVerify" class="mt-4 w-25 btn-login" v-show="showEditModel">提交认证</el-button>
        </el-col>
        <el-col :span="8">
            <!--这里不允许拖拽maker，因为拖拽以后maker经纬度更新并能成功保存到后台
          但是页面上仍然是根据左侧的省市区和详细地址推算出来的大致位置-->
          <div v-if="BasicInfo.longitude">
            <b-map class="w-100 ml-2 mt-2"
                suggestId=""
                eleHeight="400"
                @onConfirm="point => getCityInfo(point, 'son')"
                @setStoreTitle="(v)=>this.BasicInfo.title = v"
                @dragMarker="position"
                :WheelZoom="true"
                :allowDrag="showEditModel"
                :nip='Model'
                :markPoint="storePoint"
                :MapArea="MapArea"/>
                    <div class="lies">
          <span class="text-danger">*</span>
              地图选点:
              <p>(经度)
                <span class="text-blue">{{longitude||this.BasicInfo.longitude}}</span>
              </p>
              <p>(纬度)
                <span class="text-blue">{{latitude||this.BasicInfo.latitude}}</span>
              </p>
          </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog title="提交信息" :visible.sync="showConfirmPanel" width="680px" center id="loadConfirm">
        <Verify-Info-Text :priceArrs='Informationtext'/>
        <div slot="footer">
          <el-button size="small" type="primary" @click="showConfirmPanel = false">返回</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import { mapState,mapGetters,mapActions } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import BMap from '../../../../components/BMap/BMap'
  import VerifyInfoText from './VerifyInfoText.vue'
  export default {
    name: 'VerifyInfo',
    components: { BMap,VerifyInfoText},
    computed: {
      ...mapState(['StoreBasicInfo','Informationtext']),
      ...mapGetters(['storeInfo','isGroup','userInfo']),
      storeId() { return this.$route.query.store},
      TitleMsg() {
        if (this.BasicInfo.edit_status==1) return '认证信息已提交，请耐心等待...'
        else return '变更认证信息需要提交申请，待后台审核通过后方能变更成功。'
      },
      storePoint () {      //传入给BMap组件的门店经纬度地址信息，默认公司地址
        return [{
            lng: this.BasicInfo.longitude ? Number(this.BasicInfo.longitude) : 120.206194,
            lat: this.BasicInfo.latitude ? Number(this.BasicInfo.latitude) : 30.291275,
            IconPng: require('../../../../../public/images/public/icon.png'),
            nid:true
          }]
      },
      MapArea () {     //传入给BMap组件的区域地址信息
        return {
          province: this.BasicInfo.province_name,
          city: this.BasicInfo.city_name,
          district: this.BasicInfo.district_name,
          address: this.BasicInfo.address
        }
      }
    },
    data() {
      return {
        title: '',                    //门店名称
        showEditModel:false,        //编辑认证信息模式
        showConfirmPanel:false,
        snp:false,
        Model:true,
        reason: '',
        otherReason: '',
        longitude:'',
        latitude:'',
        reasonsArr: [
          '单位名称变更',
          '营业执照有修改',
          '人事调动',
          '手动填写其他原因'
        ],                   //重新认证的理由
        lonLatInfo:{},          //门店经纬度信息，BMap组件不直接修改BasicInfo中的经纬度值，会引起重复渲染maker标记点
        BasicInfo: {},
        addressDetail: '',
        pcd: '',
        Title: '',
        weit:0,//判断是否微调
        verifyImg: '',                //重新上传的营业执照照片
        certfire	: '',               //消防验收合格证
        certheal	: '',               //卫生许可证
        certspec: '',                 //特种行业许可证
      }
    },
    watch: {
      StoreBasicInfo (newVal) {
        // this.BasicInfo = newVal;
        // this.verifyImg = this.BasicInfo.certpic;
        this.initStoreInfo()
      },
      // storeId(newVal) {
      //   console.log('storeId',newVal) 
      //   this.getInfo(newVal);
      // }
    },
    created () {
      this.initStoreInfo()
      this.getInfo(this.storeId);
    },
    methods:{
      ...mapActions(['setStoreVerify','logout','information','getStoreInfo']),
      /*获取门店信息*/
      getInfo(storeId) {
        console.log(storeId);
        let data = {};
        //管理员需要获取设置签约身份、门店负责人的数组
        if (this.isAdmin) {
          data.is_get_contract_arr = '1';
          data.is_get_admin_user_arr = '1';
        }
        if(storeId) data.store_id = storeId;
        this.getStoreInfo(data);
      },
      /*查看编辑认证信息*/
      editinformation(){
        this.showConfirmPanel = !this.showConfirmPanel;
        this.information();
      },
      initStoreInfo () {
        this.BasicInfo = {...this.StoreBasicInfo}
        this.addressDetail = this.BasicInfo.address;
        this.title = this.BasicInfo.title;
        // this.title = this.StoreBasicInfo.title;
        this.verifyImg = this.StoreBasicInfo.certpic;
        this.certfire = this.StoreBasicInfo.certfire;
        this.certheal = this.StoreBasicInfo.certheal;
        this.certspec = this.StoreBasicInfo.certspec;
        this.lonLatInfo.lng= this.BasicInfo.longitude;
        this.lonLatInfo.lat=this.BasicInfo.latitude;
        this.pcd = this.BasicInfo.province_name + '' + this.BasicInfo.city_name + '' + this.BasicInfo.district_name
      },
      /**点击编辑 */
      confirmSubmit(){
        this.showEditModel = !this.showEditModel;
        //点返回更新数据
        if(!this.showEditModel){
          this.initStoreInfo();
        }
      },
      position(e){
        this.lonLatInfo=e;
        this.longitude = e.lng; this.latitude = e.lat;
        this.storePoint[0].nid=false
      },
      /*获取省市区id和name*/
      getCityInfo (info) {
        console.log(info);
        for (let key in info) {
          this.$set(this.BasicInfo,key,info[key]);
        }
      },
      validateForm() {
        if (!this.title) return {code: false, msg: '名称不得为空'};
        if (!this.verifyImg) return {code: false, msg: '请上传营业执照'};
        if (!this.reason) return {code: false, msg: '请选择修改认证信息的理由'};
        if (this.reason === '手动填写其他原因' && !this.otherReason) return {code: false, msg: '请填写其他理由'};
        return {code: true, msg: '验证通过'}
      },
      reVerify() {
        let result = this.validateForm();
        this.BasicInfo.title = this.title
        if (result.code) {
          let msg = this.isGroup ? '确定为该门店提交认证信息么？' : '认证信息提交申请期间，不影响原认证信息的使用，待通过后会更新原认证信息。确认提交么？';
          this._confirm(msg, async () => {
            //处理基本信息中的营业执照
            this.verifyImg = (await UploadImages(this.verifyImg))[0];
            this.certfire = (await UploadImages(this.certfire))[0];
            this.certheal = (await UploadImages(this.certheal))[0];
            this.certspec = (await UploadImages(this.certspec))[0];
            this.BasicInfo.longitude = this.lonLatInfo.lng;
            this.BasicInfo.latitude = this.lonLatInfo.lat;
            this.setStoreVerify({
              data:{
                province:this.BasicInfo.province,
                province_name:this.BasicInfo.province_name,
                city:this.BasicInfo.city,
                city_name:this.BasicInfo.city_name,
                district:this.BasicInfo.district,
                district_name:this.BasicInfo.district_name,
                address:this.BasicInfo.address,
                title: this.BasicInfo.title,
                latitude: this.BasicInfo.latitude,
                longitude: this.BasicInfo.longitude,
                certpic: this.verifyImg,
                certfire: this.certfire,
                certheal: this.certheal,
                certspec: this.certspec,
                reason: this.reason === '手动填写其他原因' ? this.otherReason : this.reason,
                storeId:this.storeId
              },
              verify: '3',
              successFun:() => {
                this.showEditModel = !this.showEditModel;
                this.Model=!this.Model;
                this.getStoreInfo();
                this.initStoreInfo();
              }
            })
          });
        } else this._alert(result.msg,null,'error')
      }
    }
  }
</script>
<style scoped>
.lies{
  margin-top: 10px;
}
.lies p{
  margin-top: 10px;
}
.red{
  color: red;
}
.list-text{
  color: #999;
}
</style>
